module.exports = __webpack_public_path__ + "img/vue3-web3-4.3417f959.jpg";